module.exports = __webpack_public_path__ + "static/img/per3.b486539.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/per3.jpg
// module id = APz1
// module chunks = 41